import React, { useEffect, useState } from 'react';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
interface PricingProps {
  id?: string;
}
export function Pricing({
  id = 'pricing'
}: PricingProps) {
  const [selectedPlan, setSelectedPlan] = useState<'standard' | 'elite'>('elite');
  // Countdown timer logic (starting from 22:47:20)
  const [timeLeft, setTimeLeft] = useState({
    hours: 22,
    minutes: 47,
    seconds: 20
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  const handleCheckout = () => {
    if (selectedPlan === 'standard') {
      window.location.href = 'https://pagos.recursosfitness.shop/cart/44089445646433:1';
    } else {
      window.location.href = 'https://pagos.recursosfitness.shop/cart/44089445777505:1';
    }
  };
  return <section id={id} className="py-6 md:py-24 bg-brand-dark relative overflow-hidden text-white" data-id="element-217">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-218">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-brand-accent blur-3xl" data-id="element-219"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-220">
        <div className="text-center mb-4 md:mb-10" data-id="element-221">
          <h2 className="text-xl md:text-5xl font-serif font-bold mb-1.5 md:mb-6 text-white" data-id="element-222">
            ELEGÍ TU PATINAJE ARTÍSTICO RESUELTO
          </h2>
          <p className="text-sm md:text-xl text-brand-ice/80 mb-3 md:mb-8" data-id="element-223">
            Las dos opciones incluyen los 6 bonos completos
          </p>

          {/* Urgency Bar - Compact on mobile */}
          <div className="max-w-md mx-auto bg-brand-light/50 backdrop-blur-sm p-3 md:p-6 rounded-xl md:rounded-2xl shadow-sm border border-brand-light mb-4 md:mb-8" data-id="element-224">
            <div className="flex justify-between text-[10px] md:text-sm font-bold text-brand-ice/80 mb-1.5" data-id="element-225">
              <span data-id="element-226">Cupos al precio de lanzamiento</span>
              <span className="text-brand-accent" data-id="element-227">68% tomados</span>
            </div>
            <div className="w-full bg-brand-dark/50 rounded-full h-2 md:h-3 mb-2.5 md:mb-6 overflow-hidden" data-id="element-228">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '68%'
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="bg-brand-accent h-full rounded-full" data-id="element-229"></motion.div>
            </div>

            <div className="text-[9px] md:text-sm font-bold text-brand-ice/60 mb-1.5 uppercase tracking-wider" data-id="element-230">
              EL PRECIO DE LANZAMIENTO TERMINA EN:
            </div>
            <div className="flex justify-center space-x-1 md:space-x-2 text-base md:text-2xl font-mono font-bold text-white" data-id="element-231">
              <div className="bg-brand-dark/50 px-2 md:px-3 py-1 md:py-2 rounded-lg min-w-[38px] md:min-w-[60px] border border-brand-light" data-id="element-232">
                {formatTime(timeLeft.hours)}
              </div>
              <span className="py-1 md:py-2 text-brand-ice/60" data-id="element-233">:</span>
              <div className="bg-brand-dark/50 px-2 md:px-3 py-1 md:py-2 rounded-lg min-w-[38px] md:min-w-[60px] border border-brand-light" data-id="element-234">
                {formatTime(timeLeft.minutes)}
              </div>
              <span className="py-1 md:py-2 text-brand-ice/60" data-id="element-235">:</span>
              <div className="bg-brand-dark/50 px-2 md:px-3 py-1 md:py-2 rounded-lg min-w-[38px] md:min-w-[60px] text-brand-accent border border-brand-light" data-id="element-236">
                {formatTime(timeLeft.seconds)}
              </div>
            </div>
            <p className="text-[9px] md:text-xs text-brand-ice/60 mt-1.5 md:mt-3" data-id="element-237">
              Después sube $8.000 ARS y no vuelve a bajar.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-2.5 md:gap-6 mb-4 md:mb-8" data-id="element-238">
          {/* Standard Plan */}
          <div onClick={() => setSelectedPlan('standard')} className={`relative flex items-center p-3 md:p-6 rounded-xl md:rounded-2xl border-2 cursor-pointer transition-all ${selectedPlan === 'standard' ? 'border-brand-accent bg-brand-light/80 shadow-[0_0_20px_rgba(196,154,108,0.15)]' : 'border-brand-light bg-brand-dark hover:border-brand-light/80'}`} data-id="element-239">
            {/* Radio Button */}
            <div className="flex-shrink-0 mr-3 md:mr-6" data-id="element-240">
              <div className={`w-5 h-5 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'standard' ? 'border-brand-accent' : 'border-brand-ice/50'}`} data-id="element-241">
                {selectedPlan === 'standard' && <div className="w-2.5 h-2.5 md:w-3.5 md:h-3.5 rounded-full bg-brand-accent" data-id="element-242" />}
              </div>
            </div>

            {/* Content */}
            <div className="flex-grow flex items-center justify-between gap-2" data-id="element-243">
              <div data-id="element-244">
                <div className="flex items-center gap-1.5 mb-0.5" data-id="element-245">
                  <span className="text-sm md:text-xl" data-id="element-246">🛼</span>
                  <h3 className="text-sm md:text-xl font-bold text-white uppercase tracking-wide" data-id="element-247">
                    PATINAJE ARTÍSTICO RESUELTO
                  </h3>
                </div>
                <p className="text-[10px] md:text-sm text-brand-ice/60" data-id="element-248">
                  6 tomos + 120 clases + bonos
                </p>
              </div>

              <div className="text-right flex-shrink-0" data-id="element-249">
                <div className="text-[10px] md:text-sm text-brand-ice/50 line-through" data-id="element-250">
                  $34.990
                </div>
                <div className={`text-lg md:text-3xl font-bold ${selectedPlan === 'standard' ? 'text-brand-accent' : 'text-white'}`} data-id="element-251">
                  $19.990
                </div>
              </div>
            </div>
          </div>

          {/* Elite Plan */}
          <div onClick={() => setSelectedPlan('elite')} className={`relative flex items-center p-3 md:p-6 rounded-xl md:rounded-2xl border-2 cursor-pointer transition-all ${selectedPlan === 'elite' ? 'border-brand-accent bg-brand-light/80 shadow-[0_0_20px_rgba(196,154,108,0.15)]' : 'border-brand-light bg-brand-dark hover:border-brand-light/80'}`} data-id="element-252">
            {/* Radio Button */}
            <div className="flex-shrink-0 mr-3 md:mr-6" data-id="element-253">
              <div className={`w-5 h-5 md:w-7 md:h-7 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'elite' ? 'border-brand-accent' : 'border-brand-ice/50'}`} data-id="element-254">
                {selectedPlan === 'elite' && <div className="w-2.5 h-2.5 md:w-3.5 md:h-3.5 rounded-full bg-brand-accent" data-id="element-255" />}
              </div>
            </div>

            {/* Content */}
            <div className="flex-grow flex items-center justify-between gap-2" data-id="element-256">
              <div data-id="element-257">
                <div className="flex items-center gap-1.5 mb-1" data-id="element-258">
                  <span className="text-sm md:text-xl" data-id="element-259">🏆</span>
                  <h3 className="text-sm md:text-xl font-bold text-white uppercase tracking-wide" data-id="element-260">
                    PACK ÉLITE
                  </h3>
                </div>

                <div className="flex flex-wrap gap-1 md:gap-2 mb-1" data-id="element-261">
                  <div className="bg-brand-accent text-brand-dark text-[9px] md:text-xs font-bold px-1.5 py-0.5 md:px-2 md:py-1 rounded flex items-center" data-id="element-262">
                    <Star className="w-2.5 h-2.5 md:w-3 md:h-3 mr-0.5 fill-current" data-id="element-263" />
                    MÁS ELEGIDO
                  </div>
                  <div className="border border-brand-accent text-brand-accent text-[9px] md:text-xs font-bold px-1.5 py-0.5 md:px-2 md:py-1 rounded" data-id="element-264">
                    AHORRÁS $16.000
                  </div>
                </div>

                <p className="text-[10px] md:text-sm text-brand-ice/60" data-id="element-265">
                  6 tomos + 2 módulos exclusivos + bonos
                </p>
              </div>

              <div className="text-right flex-shrink-0" data-id="element-266">
                <div className="text-[10px] md:text-sm text-brand-ice/50 line-through" data-id="element-267">
                  $43.990
                </div>
                <div className={`text-lg md:text-3xl font-bold ${selectedPlan === 'elite' ? 'text-brand-accent' : 'text-white'}`} data-id="element-268">
                  $27.990
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center" data-id="element-269">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={handleCheckout} className="w-full bg-brand-accent hover:bg-brand-accentHover text-brand-dark font-bold text-base md:text-xl px-4 md:px-8 py-3 md:py-5 rounded-xl shadow-lg shadow-brand-accent/20 transition-all flex items-center justify-center" data-id="element-270">
            SÍ, QUIERO MI PATINAJE ARTÍSTICO RESUELTO →
          </motion.button>

          <p className="text-brand-ice/60 text-xs md:text-sm italic mt-2 md:mt-4" data-id="element-271">
            La opción más elegida por profes de patinaje
          </p>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-2.5 md:gap-8 mt-4 md:mt-8 p-2.5 md:p-4 rounded-xl border border-brand-light bg-brand-light/30 text-[10px] md:text-sm text-brand-ice/80" data-id="element-272">
          <div className="flex items-center" data-id="element-273">
            <span className="mr-1 md:mr-2 text-sm md:text-lg" data-id="element-274">🔒</span> Pago
            seguro
          </div>
          <div className="flex items-center" data-id="element-275">
            <span className="mr-1 md:mr-2 text-sm md:text-lg" data-id="element-276">⚡</span> Acceso
            en 5 min
          </div>
          <div className="flex items-center" data-id="element-277">
            <span className="mr-1 md:mr-2 text-sm md:text-lg" data-id="element-278">🛡️</span> Garantía
            7 días
          </div>
          <div className="flex items-center" data-id="element-279">
            <span className="mr-1 md:mr-2 text-sm md:text-lg" data-id="element-280">💳</span> Mercado
            Pago
          </div>
        </div>
      </div>
    </section>;
}